module.exports = __webpack_public_path__ + "img/icon8.a3af2bd.png";